import React from 'react';

const PutniNalogZaStampu = ({ podaci }) => {

  const {
    vucno = [],
    prikolica = [],
    vozaci = [],
    ostaliClanoviPosade = [],
    relacija = '',
    dozvole = '',
    kreiraoNalog = '',
    mestoIzdavanja = '',
    ulica = '',
    datumIzdavanja = '',
    brojNaloga = '',
    nazivPreduzeca = ''
  } = podaci ?? {};

const printStyles = `
/* Global reset */
* { box-sizing: border-box; }
html, body, #print-content, #print-content > * {
  margin: 0 !important;
  padding: 0 !important;
}

/* Named pages */
@page { margin: 0; }                 /* default: bez margina */
@page with-margins {                 /* 1. strana sa marginama (po želji) */
  margin: 0.75in 0.7in 0.75in 0.7in;
}
@page no-margins { margin: 0; }      /* 2. strana: bez margina */

.first-page  { page: with-margins; }
.second-page { page: no-margins;  }

  /* Tvoji stilovi za prvu stranu */
  .putni-nalog-container { margin: 5% !important; width: 100%; }
  .putni-nalog-container tr { border-right: none; }
  table { width: 100%; border-collapse: collapse; }
  td {
    padding: 2px;
    vertical-align: top;
    background-color: white;
    border: 1px solid black;
  }
  .text-center { text-align: center; }
  .bold { font-weight: bold; }
  .empty-cell { height: 20px; }
  .column12 {width: 10%}
  .column5 { width: 4%; border-top: none; border-bottom: none; border-right: none; }
  .column6, .column7, .column8, .column9, .column10, .column11, .column12, .column13 { border: none; }
  .borderLeftAndRightNone { border-left: none !important; border-right: none !important; }
  .borderBottomNone { border-bottom: none !important; }
  .displayTextFlex { text-align:center; }
  .verticalAlign { vertical-align: middle; }
  .borderTopNone { border-top: none !important; }
  .borderLeftNone { border-left: none !important; }
  .borderRightNone { border-right: none !important; }
  .borderSecondTable { border: 1px solid black; padding: 4px 8px; }
  .cellHeight { height: 15px !important; }
  .paddingLeft10px {
  padding: 10px !important;
  }

  .wrapCell {
  white-space: normal !important;
  height: auto !important;
  line-height: 1.2 !important;
  overflow: visible !important;   /* pregazi eventualni overflow:hidden */
}

/* DRUGA STRANA — apsolutno ankerovanje slike bez pomeranja */
.second-page {
  position: relative !important;
  width: 100vw;       /* širina page box-a */
  height: 100vh;      /* visina page box-a */
  overflow: hidden;   /* ništa ne preliva na treću */
  border: 0 !important;
  outline: 0 !important;
  background: transparent !important;
}
.second-page td {
border: 1px solid black;
}

/* KLJUČ: apsolutno pozicioniran IMG, bez margina/paddinga/transforma */
.second-page .pdf-img {
 position: absolute !important;
  top: 0; left: 0; right: 0; bottom: 0;  /* zalepi na sve ivice */
  display: block !important;
  margin: 0 !important;
  padding: 0 !important;
  border: 0 !important;

  width: 100% !important;
  height: 100% !important;

  object-fit: contain;           /* vidi se cela PDF slika */
  object-position: left top;     /* PORAVNANJE: gornji-levo (nema “bežanja” udesno) */
  transform: none !important;
}

/* (Ako koristiš rotiranu tabelu umesto slike) */
/*.second-page .rotated-table-container {
  position: relative; width: 100vw; height: 100vh; margin: 0; padding: 0; overflow: hidden;
}
  
.second-page .rotated-table {
  position: absolute; top: 0; left: 0;
  transform: rotate(-90deg);
  transform-origin: top left;
  width: 100vh; /* visina papira postaje širina tabele */
  border-collapse: collapse;
}*/

/* PRINT: sakrij sve posle 2. “strane” */
@media print {
  .putni-nalog-container {
  margin: 5% !important;
  }
  body {
  height: auto;
  }
  #print-content > *:nth-of-type(n + 3) { display: none !important; }
  /* (opciono) Zaključa orijentaciju papira:
     @page { size: A4 portrait; }  ili  landscape  */
  .landscape-wrapper > *:nth-of-type(n + 2) { display: none !important; }
}

`;

  return (
    <>
    <div className="putni-nalog-container">
      <style>{printStyles}</style>
      
      <table className="sheet0">
        <colgroup>
          <col className="col0" />
          <col className="col1" />
          <col className="col2" />
          <col className="col3" />
          <col className="col4" />
          <col className="col5" />
          <col className="col6" />
          <col className="col7" />
          <col className="col8" />
          <col className="col9" />
          <col className="col10" />
          <col className="col11" />
          <col className="col12" />
          <col className="col13" />
        </colgroup>
        
        <tbody>
          {/* Prvi red - Potrošnja goriva i zaglavlje */}
          <tr>
            <td className="column0 bold displayTextFlex verticalAlign" colSpan="2" style={{borderTop: '2px solid black', borderLeft: '2px solid black', borderRight: '1px solid black', borderBottom: '1px solid black'}}>Potrošnja goriva</td>
            <td className="column2 displayTextFlex verticalAlign" rowSpan="2" style={{borderTop: '2px solid black', verticalAlign: 'middle', borderBottom: '1px solid black', borderRight: '1px solid black'}}>litara</td>
            <td className="column3 displayTextFlex verticalAlign" rowSpan="2" style={{borderTop: '2px solid black' , verticalAlign: 'middle', borderBottom: '1px solid black', borderRight: '1px solid black'}}>kilometri</td>
            <td className="column4 displayTextFlex verticalAlign" rowSpan="2" style={{borderTop: '2px solid black', borderRight: '2px solid black', verticalAlign: 'middle' , borderBottom: '1px solid black'}}>potpis</td>
            <td className="column5"></td>
            <td className="column6" colSpan="6" rowSpan="3" style={{width: '25%'}}>
              Obrazac propisan Pravilnikom o sadrzini, izdavanju i vodjenju putnih naloga I evidenciji o izdatim putnim nalozima objavljenim u "Sluzbenom glasniku Republike Srbije" 20/96
            </td>
            <td className="column12"></td>
            <td className="column13"></td>
          </tr>
          
          {/* Drugi red - Datum i mesto */}
          <tr>
            <td className="column0 displayTextFlex verticalAlign" style={{borderLeft: '2px solid black', borderRight: '1px solid black', borderBottom: '1px solid black'}}>datum</td>
            <td className="column1 displayTextFlex verticalAlign" style={{borderBottom: '1px solid black', borderRight: '1px solid black'}}>mesto</td>
            <td className="column5"></td>
            <td className="column12"></td>
            <td className="column13"></td>
          </tr>
          
          {/* Prazni redovi */}
          <tr>
            <td className="column0 empty-cell cellHeight" style={{borderLeft: '2px solid black', borderBottom: '1px dotted black', borderRight: '1px dotted black'}}></td>
            <td className="column1 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderRight: '1px dotted black'}}></td>
            <td className="column2 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderRight: '1px dotted black'}}></td>
            <td className="column3 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderRight: '1px dotted black'}}></td>
            <td className="column4 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderRight: '2px solid black' }}></td>
            <td className="column5"></td>
            <td className="column12"></td>
            <td className="column13"></td>
          </tr>
          
          <tr>
            <td className="column0 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderLeft: '2px solid black', borderRight: '1px dotted black'}}></td>
            <td className="column1 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderRight: '1px dotted black'}}></td>
            <td className="column2 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderRight: '1px dotted black'}}></td>
            <td className="column3 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderRight: '1px dotted black'}}></td>
            <td className="column4 empty-cell cellHeight" style={{ borderBottom: '1px dotted black',borderRight: '2px solid black' }}></td>
            <td className="column5"></td>
            <td className="column6"></td>
            <td className="column7"></td>
            <td className="column8"></td>
            <td className="column9"></td>
            <td className="column10"></td>
            <td className="column11"></td>
            <td className="column12"></td>
            <td className="column13"></td>
          </tr>
          
          <tr>
            <td className="column0 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderLeft: '2px solid black', borderRight: '1px dotted black'}}></td>
            <td className="column1 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderRight: '1px dotted black'}}></td>
            <td className="column2 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderRight: '1px dotted black'}}></td>
            <td className="column3 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderRight: '1px dotted black'}}></td>
            <td className="column4 empty-cell cellHeight" style={{ borderRight: '2px solid black', borderBottom: '1px dotted black'}}></td>
            <td className="column5"></td>
            <td className="column6" colSpan="8"></td>
          </tr>
          
          {/* Naziv preduzeća */}
          <tr>
            <td className="column0 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderLeft: '2px solid black', borderRight: '1px dotted black'}}></td>
            <td className="column1 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderRight: '1px dotted black'}}></td>
            <td className="column2 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderRight: '1px dotted black'}}></td>
            <td className="column3 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderRight: '1px dotted black'}}></td>
            <td className="column4 empty-cell cellHeight" style={{ borderRight: '2px solid black', borderBottom: '1px dotted black'}}></td>
            <td className="column5"></td>
            <td className="column6 text-center" colSpan="8" style={{borderBottom: "1px solid black"}}>
              {nazivPreduzeca || 'naziv prevozinika'}
            </td>
          </tr>
          
          {/* Prazan red */}
          <tr>
            <td className="column0 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderLeft: '2px solid black', borderRight: '1px dotted black'}}></td>
            <td className="column1 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderRight: '1px dotted black'}}></td>
            <td className="column2 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderRight: '1px dotted black'}}></td>
            <td className="column3 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderRight: '1px dotted black'}}></td>
            <td className="column4 empty-cell cellHeight" style={{ borderRight: '2px solid black', borderBottom: '1px dotted black'}}></td>
            <td className="column5"></td>
            <td className="column6"></td>
            <td className="column7"></td>
            <td className="column8"></td>
            <td className="column9"></td>
            <td className="column10 displayTextFlex verticalAlign" colSpan="3">(naziv prevozinika)</td>
            <td className="column13"></td>
          </tr>
          
          {/* Mesto i ulica */}
          <tr>
            <td className="column0 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderLeft: '2px solid black', borderRight: '1px dotted black'}}></td>
            <td className="column1 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderRight: '1px dotted black'}}></td>
            <td className="column2 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderRight: '1px dotted black'}}></td>
            <td className="column3 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderRight: '1px dotted black'}}></td>
            <td className="column4 empty-cell cellHeight" style={{ borderRight: '2px solid black', borderBottom: '1px dotted black'}}></td>
            <td className="column5"></td>
            <td className="column6 displayTextFlex verticalAlign" style={{textAlign: 'left'}}>Mesto:</td>
            <td className="column7 displayTextFlex verticalAlign" colSpan="2" style={{borderBottom: "1px solid black"}}>{mestoIzdavanja}</td>
            <td className="column9 displayTextFlex verticalAlign">Ulica:</td>
            <td className="column10 displayTextFlex verticalAlign" colSpan="4" style={{borderBottom: "1px solid black"}}>{ulica}</td>
          </tr>
          
          {/* Prazan red */}
          <tr>
            <td className="column0 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderLeft: '2px solid black', borderRight: '1px dotted black'}}></td>
            <td className="column1 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderRight: '1px dotted black'}}></td>
            <td className="column2 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderRight: '1px dotted black'}}></td>
            <td className="column3 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderRight: '1px dotted black'}}></td>
            <td className="column4 empty-cell cellHeight" style={{ borderRight: '2px solid black', borderBottom: '1px dotted black'}}></td>
            <td className="column5"></td>
            <td className="column6"></td>
            <td className="column7"></td>
            <td className="column8"></td>
            <td className="column9"></td>
            <td className="column10"></td>
            <td className="column11"></td>
            <td className="column12"></td>
            <td className="column13"></td>
          </tr>
          
          {/* Datum izdavanja i broj */}
          <tr>
            <td className="column0 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderLeft: '2px solid black', borderRight: '1px dotted black'}}></td>
            <td className="column1 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderRight: '1px dotted black'}}></td>
            <td className="column2 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderRight: '1px dotted black'}}></td>
            <td className="column3 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderRight: '1px dotted black'}}></td>
            <td className="column4 empty-cell cellHeight" style={{ borderRight: '2px solid black', borderBottom: '1px dotted black'}}></td>
            <td className="column5"></td>
            <td className="column6 displayTextFlex verticalAlign" colSpan="2" style={{textAlign: 'left'}}>Datum izdavanja:</td>
            <td className="column8 displayTextFlex verticalAlign" style={{borderBottom: "1px solid black"}}>{datumIzdavanja}</td>
            <td className="column9 displayTextFlex verticalAlign">Broj:</td>
            <td className="column10 displayTextFlex verticalAlign" colSpan="2" style={{borderBottom: "1px solid black"}}>{brojNaloga}</td>
            <td className="column12"></td>
            <td className="column13"></td>
          </tr>
          
          {/* Prazan red */}
          <tr>
            <td className="column0 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderLeft: '2px solid black', borderRight: '1px dotted black'}}></td>
            <td className="column1 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderRight: '1px dotted black'}}></td>
            <td className="column2 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderRight: '1px dotted black'}}></td>
            <td className="column3 empty-cell cellHeight" style={{borderBottom: '1px dotted black', borderRight: '1px dotted black'}}></td>
            <td className="column4 empty-cell cellHeight" style={{ borderRight: '2px solid black', borderBottom: '1px dotted black'}}></td>
            <td className="column5"></td>
            <td className="column6"></td>
            <td className="column7"></td>
            <td className="column8"></td>
            <td className="column9"></td>
            <td className="column10"></td>
            <td className="column11"></td>
            <td className="column12"></td>
            <td className="column13"></td>
          </tr>
          
          {/* PUTNI NALOG naslov */}
          <tr>
            <td className="column0 empty-cell cellHeight" style={{borderLeft: '2px solid black', borderRight: '1px dotted black', borderBottom: '2px solid black' }}></td>
            <td className="column1 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom: '2px solid black' }}></td>
            <td className="column2 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom: '2px solid black' }}></td>
            <td className="column3 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom: '2px solid black' }}></td>
            <td className="column4 empty-cell cellHeight" style={{ borderRight: '2px solid black', borderBottom: '2px solid black' }}></td>
            <td className="column5"></td>
            <td className="column6"></td>
            <td className="column7"></td>
            <td className="column8"></td>
            <td className="column9 text-center bold displayTextFlex verticalAlign" colSpan="3">PUTNI NALOG</td>
            <td className="column11"></td>
            <td className="column12"></td>
            <td className="column13"></td>
          </tr>
          
          {/* Potrošnja goriva */}
          <tr>
            <td className="column0 bold displayTextFlex verticalAlign" colSpan="2" style={{borderLeft: '2px solid black',borderBottom: '2px solid black'}}>Potrošnja goriva:</td>
            <td className="column2 empty-cell cellHeight" style={{borderBottom: '2px solid black'}}></td>
            <td className="column3 empty-cell cellHeight" style={{borderBottom: '2px solid black'}}></td>
            <td className="column4 empty-cell cellHeight" style={{ borderRight: '2px solid black', borderBottom: '2px solid black'}}></td>
            <td className="column5"></td>
            <td className="column6"></td>
            <td className="column7"></td>
            <td className="column8"></td>
            <td className="column9"></td>
            <td className="column10"></td>
            <td className="column11"></td>
            <td className="column12"></td>
            <td className="column13"></td>
          </tr>
          
          {/* Ime prezime vozača */}
          <tr>
            <td className="borderLeftAndRightNone column0 empty-cell cellHeight" colSpan="2" ></td>
            <td className="borderLeftAndRightNone column2 empty-cell cellHeight"></td>
            <td className="borderLeftAndRightNone column3 empty-cell cellHeight"></td>
            <td className="borderLeftAndRightNone column4 empty-cell cellHeight" style={{ borderRight: '2px solid black' }}></td>
            <td className="borderLeftAndRightNone column5"></td>
            <td className="column6 displayTextFlex verticalAlign" colSpan="3" style={{textAlign: 'left'}}>Ime prezime vozača:</td>
            <td className="column9" colSpan="4" style={{borderBottom: "1px solid black"}}>{vozaci.join(', ')}</td>
            <td className="column13" ></td>
          </tr>
          
          {/* Potrošnja Adblue */}
          <tr>
            <td className="column0 bold displayTextFlex verticalAlign" colSpan="2" style={{borderLeft: '2px solid black', borderTop: '2px solid black' , borderRight: '1px solid black', borderBottom: '1px solid black'}}>Potrošnja Adblue</td>
            <td className="column2 displayTextFlex verticalAlign" rowSpan="2" style={{ borderTop: '2px solid black', verticalAlign: 'middle', borderRight: '1px solid black', borderBottom: '1px solid black'}}>litara</td>
            <td className="column3 displayTextFlex verticalAlign" rowSpan="2" style={{ borderTop: '2px solid black', verticalAlign: 'middle', borderRight: '1px solid black', borderBottom: '1px solid black'}}>kilometri</td>
            <td className="column4 displayTextFlex verticalAlign" rowSpan="2" style={{ borderTop: '2px solid black', borderRight: '2px solid black', verticalAlign: 'middle', borderBottom: '1px solid black'}}>potpis</td>
            <td className="column5"></td>
            <td className="column6"></td>
            <td className="column7"></td>
            <td className="column8"></td>
            <td className="column9"></td>
            <td className="column10"></td>
            <td className="column11"></td>
            <td className="column12"></td>
            <td className="column13"></td>
          </tr>
          
          <tr>
            <td className="column0 displayTextFlex verticalAlign" style={{ borderLeft: '2px solid black', borderRight: '1px solid black', borderBottom: '1px solid black' }}>datum</td>
            <td className="column1 displayTextFlex verticalAlign" style={{ borderRight: '1px solid black', borderBottom: '1px solid black' }}>mesto</td>
            <td className="column5"></td>
            <td className="column6 displayTextFlex verticalAlign" colSpan="3" style={{textAlign: 'left'}}>Ime prezime ostalih čl. posade:</td>
            <td className="column9" colSpan="4" style={{borderBottom: "1px solid black"}}>{ostaliClanoviPosade.join(', ')}</td>
          </tr>
          
          {/* Prazan red */}
          <tr>
            <td className="column0 empty-cell cellHeight" style={{ borderLeft: '2px solid black', borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column1 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column2 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column3 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column4 empty-cell cellHeight" style={{ borderRight: '2px solid black', borderBottom:'1px dotted black'}}></td>
            <td className="column5"></td>
            <td className="column6"></td>
            <td className="column7"></td>
            <td className="column8"></td>
            <td className="column9"></td>
            <td className="column10"></td>
            <td className="column11"></td>
            <td className="column12"></td>
            <td className="column13"></td>
          </tr>
          
          {/* Relacija */}
          <tr>
            <td className="column0 empty-cell cellHeight" style={{ borderLeft: '2px solid black', borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column1 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column2 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column3 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column4 empty-cell cellHeight" style={{ borderRight: '2px solid black', borderBottom:'1px dotted black'}}></td>
            <td className="column5"></td>
            <td className="column6 displayTextFlex verticalAlign" style={{textAlign: 'left'}}>Relacija:</td>
            <td className="column7" colSpan="6" style={{borderBottom: "1px solid black"}}>{relacija}</td>
            <td className="column13"></td>
          </tr>
          
          {/* Prazan red */}
          <tr>
            <td className="column0 empty-cell cellHeight" style={{ borderLeft: '2px solid black', borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column1 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column2 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column3 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column4 empty-cell cellHeight" style={{ borderRight: '2px solid black', borderBottom:'1px dotted black'}}></td>
            <td className="column5"></td>
            <td className="column6"></td>
            <td className="column7"></td>
            <td className="column8"></td>
            <td className="column9"></td>
            <td className="column10"></td>
            <td className="column11"></td>
            <td className="column12"></td>
            <td className="column13"></td>
          </tr>
          
          {/* Dozvole */}
          <tr>
            <td className="column0 empty-cell cellHeight" style={{ borderLeft: '2px solid black', borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column1 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column2 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column3 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column4 empty-cell cellHeight" style={{ borderRight: '2px solid black', borderBottom:'1px dotted black'}}></td>
            <td className="column5"></td>
            <td className="column6 displayTextFlex verticalAlign" colSpan="5" style={{textAlign: 'left'}}>Dozvole (upisati broj svih dozvola ili cemta):</td>
            <td className="column11" colSpan="3" style={{borderBottom: "1px solid black"}}></td>
          </tr>
          
          {/* Prazan red */}
          <tr>
            <td className="column0 empty-cell cellHeight" style={{ borderLeft: '2px solid black', borderRight: '1px dotted black', borderBottom:'2px solid black'}}></td>
            <td className="column1 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'2px solid black'}}></td>
            <td className="column2 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'2px solid black'}}></td>
            <td className="column3 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'2px solid black'}}></td>
            <td className="column4 empty-cell cellHeight" style={{ borderRight: '2px solid black', borderBottom:'2px solid black'}}></td>
            <td className="column5"></td>
            <td className="column6"></td>
            <td className="column7"></td>
            <td className="column8"></td>
            <td className="column9"></td>
            <td className="column10"></td>
            <td className="column11"></td>
            <td className="column12"></td>
            <td className="column13"></td>
          </tr>
          
          {/* Potrošnja adblue */}
          <tr>
            <td className="column0 bold displayTextFlex verticalAlign" colSpan="2" style={{ borderLeft: '2px solid black', borderBottom:'2px solid black'}}>Potrošnja adblue:</td>
            <td className="column2 empty-cell cellHeight" style={{ borderBottom:'2px solid black'}}></td>
            <td className="column3 empty-cell cellHeight" style={{ borderBottom:'2px solid black'}}></td>
            <td className="column4 empty-cell cellHeight" style={{ borderBottom:'2px solid black', borderRight: '2px solid black'}}></td>
            <td className="column5"></td>
            <td className="column6" colSpan="8" style={{borderBottom: "1px solid black"}}>{dozvole}</td>
          </tr>
          
          {/* Prazan red */}
          <tr>
            <td className="borderLeftAndRightNone column0 empty-cell cellHeight" colSpan="2"></td>
            <td className="borderLeftAndRightNone column2 empty-cell cellHeight"></td>
            <td className="borderLeftAndRightNone column3 empty-cell cellHeight"></td>
            <td className="borderLeftAndRightNone column4 empty-cell cellHeight"></td>
            <td className="borderLeftAndRightNone column5"></td>
            <td className="column6 empty-cell"></td>
            <td className="column7 empty-cell"></td>
            <td className="column8 empty-cell"></td>
            <td className="column9 empty-cell"></td>
            <td className="column10 empty-cell"></td>
            <td className="column11 empty-cell"></td>
            <td className="column12 empty-cell"></td>
            <td className="column13 empty-cell"></td>
          </tr>
          
          {/* Frigo gorivo i podaci o vozilu */}
          <tr>
            <td className="column0 bold displayTextFlex verticalAlign" colSpan="2" style={{ borderLeft: '2px solid black', borderTop:'2px solid black', borderRight: '1px solid black', borderBottom: '1px solid black' }}>Frigo gorivo</td>
            <td className="column2 displayTextFlex verticalAlign" rowSpan="2" style={{ borderTop:'2px solid black', verticalAlign: 'middle', borderRight: '1px solid black', borderBottom: '1px solid black' }}>litara</td>
            <td className="column3 displayTextFlex verticalAlign" rowSpan="2" style={{ borderTop:'2px solid black', verticalAlign: 'middle', borderRight: '1px solid black', borderBottom: '1px solid black' }}>Radni sati</td>
            <td className="column4 displayTextFlex verticalAlign" rowSpan="2" style={{ borderRight: '2px solid black',borderTop:'2px solid black', verticalAlign: 'middle',  borderBottom: '1px solid black' }}>potpis</td>
            <td className="column5"></td>
            <td className="column6 displayTextFlex verticalAlign" colSpan="2" rowSpan="2" style={{border: "1px solid black", borderTop: "2px solid black",borderLeft: "2px solid black"}}>marka motornog vozila</td>
            <td className="column8 displayTextFlex verticalAlign" colSpan="2" rowSpan="2" style={{border: "1px solid black", borderTop: "2px solid black"}}>Registarska oznaka</td>
            <td className="column10 displayTextFlex verticalAlign" colSpan="2" rowSpan="2" style={{border: "1px solid black", borderTop: "2px solid black"}}>Oznaka područja gde je registrovano</td>
            <td className="column12 displayTextFlex verticalAlign" rowSpan="2" style={{border: "1px solid black", borderTop: "2px solid black"}}>Korisna nosivost</td>
            <td className="column13 displayTextFlex verticalAlign" rowSpan="2" style={{border: "1px solid black", borderTop: "2px solid black",borderRight: "2px solid black"}}>Sopstvena težina</td>
          </tr>
          
          <tr>
            <td className="column0 displayTextFlex verticalAlign" style={{ borderLeft: '2px solid black', borderRight: '1px solid black', borderBottom: '1px solid black' }}>datum</td>
            <td className="column1 displayTextFlex verticalAlign" style={{  borderRight: '1px solid black', borderBottom: '1px solid black' }}>mesto</td>
            <td className="column5"></td>
          </tr>
         
          {/* Podaci o vozilu - prvi red */}
          <tr>
            <td className="column0 empty-cell cellHeight" style={{ borderLeft: '2px solid black', borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column1 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column2 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column3 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column4 empty-cell cellHeight" style={{ borderRight: '2px solid black', borderBottom:'1px dotted black'}}></td>
            <td className="column5"></td>
            <td className="column6 displayTextFlex verticalAlign" colSpan="2" style={{border: "1px solid black", borderLeft: "2px solid black"}}>{vucno[0]?.marka || ''}</td>
            <td className="column8 displayTextFlex verticalAlign" colSpan="2" style={{border: "1px solid black"}}>{vucno[0]?.registarskaOznaka || ''}</td>
            <td className="column10 displayTextFlex verticalAlign" colSpan="2" style={{border: "1px solid black"}}>{vucno[0]?.oznakaPodrucja || ''}</td>
            <td className="column12 displayTextFlex verticalAlign" style={{border: "1px solid black"}}>{vucno[0]?.korisnaNosivost || ''}</td>
            <td className="column13 displayTextFlex verticalAlign" style={{border: "1px solid black",borderRight: "2px solid black"}}>{vucno[0]?.sopstvenaTezina || ''}</td>
          </tr>
          
          {/* Prazan red */}
          <tr>
            <td className="column0 empty-cell cellHeight" style={{ borderLeft: '2px solid black', borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column1 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column2 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column3 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column4 empty-cell cellHeight" style={{ borderRight: '2px solid black', borderBottom:'1px dotted black'}}></td>
            <td className="column5"></td>
            <td className="column6 displayTextFlex verticalAlign" colSpan="2" rowSpan="2" style={{border: "1px solid black",borderLeft: "2px solid black"}}>marka motornog vozila</td>
            <td className="column8 displayTextFlex verticalAlign" colSpan="2" rowSpan="2" style={{border: "1px solid black"}}>Registarska oznaka</td>
            <td className="column10 displayTextFlex verticalAlign" colSpan="2" rowSpan="2" style={{border: "1px solid black"}}>Oznaka područja gde je registrovano</td>
            <td className="column12 displayTextFlex verticalAlign" rowSpan="2" style={{border: "1px solid black"}}>Korisna nosivost</td>
            <td className="column13 displayTextFlex verticalAlign" rowSpan="2" style={{border: "1px solid black",borderRight: "2px solid black"}}>Sopstvena težina</td>
          </tr>
          
          <tr>
            <td className="column0 empty-cell cellHeight" style={{ borderLeft: '2px solid black', borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column1 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column2 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column3 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column4 empty-cell cellHeight" style={{ borderRight: '2px solid black', borderBottom:'1px dotted black'}}></td>
            <td className="column5"></td>
          </tr>
          
          {/* Podaci o vozilu - drugi red */}
          <tr>
            <td className="column0 empty-cell cellHeight" style={{ borderLeft: '2px solid black', borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column1 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column2 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column3 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column4 empty-cell cellHeight" style={{ borderRight: '2px solid black', borderBottom:'1px dotted black'}}></td>
            <td className="column5"></td>
            <td className="column6 displayTextFlex verticalAlign" colSpan="2" style={{border: "1px solid black", borderBottom: "2px solid black",borderLeft: "2px solid black"}}>{prikolica[0]?.marka || ''}</td>
            <td className="column8 displayTextFlex verticalAlign" colSpan="2" style={{border: "1px solid black", borderBottom: "2px solid black"}}>{prikolica[0]?.registarskaOznaka || ''}</td>
            <td className="column10 displayTextFlex verticalAlign" colSpan="2" style={{border: "1px solid black",borderBottom: "2px solid black"}}>{prikolica[0]?.oznakaPodrucja || ''}</td>
            <td className="column12 displayTextFlex verticalAlign" style={{border: "1px solid black",borderBottom: "2px solid black"}}>{prikolica[0]?.korisnaNosivost || ''}</td>
            <td className="column13 displayTextFlex verticalAlign" style={{border: "1px solid black",borderRight: "2px solid black",borderBottom: "2px solid black"}}>{prikolica[0]?.sopstvenaTezina || ''}</td>
          </tr>
          
          {/* Stanje ispravnosti vozila */}
          <tr>
            <td className="column0 empty-cell cellHeight" style={{ borderLeft: '2px solid black', borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column1 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column2 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column3 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'1px dotted black'}}></td>
            <td className="column4 empty-cell cellHeight" style={{ borderRight: '2px solid black', borderBottom:'1px dotted black'}}></td>
            <td className="column5"></td>
            <td className="column6"></td>
            <td className="column7"></td>
            <td className="column8 text-center bold displayTextFlex verticalAlign" colSpan="5">STANJE ISPRAVNOSTI VOZILA</td>
            <td className="column13"></td>
          </tr>
          
          <tr>
            <td className="column0 empty-cell cellHeight" style={{ borderLeft: '2px solid black', borderRight: '1px dotted black', borderBottom:'2px solid black'}}></td>
            <td className="column1 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'2px solid black'}}></td>
            <td className="column2 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'2px solid black'}}></td>
            <td className="column3 empty-cell cellHeight" style={{ borderRight: '1px dotted black', borderBottom:'2px solid black'}}></td>
            <td className="column4 empty-cell cellHeight" style={{ borderRight: '2px solid black', borderBottom:'2px solid black'}}></td>
            <td className="column5"></td>
            <td className="column6" colSpan="8">
              Ispravnost vozila utvrđena je na osnovu pregleda u odobrenoj radionici.
            </td>
          </tr>
          
          <tr>
            <td className="column0 bold displayTextFlex verticalAlign cellHeight" colSpan="2"  style={{ borderLeft: '2px solid black',borderBottom:'2px solid black'}}>Potrošnja goriva:</td>
            <td className="column2 empty-cell cellHeight" style={{ borderBottom:'2px solid black'}}></td>
            <td className="column3 empty-cell cellHeight" style={{ borderBottom:'2px solid black'}}></td>
            <td className="column4 empty-cell cellHeight" style={{ borderBottom:'2px solid black', borderRight:'2px solid black'}}></td>
            <td className="column5"></td>
            <td className="column6 displayTextFlex verticalAlign" colSpan="2">Ispravnosti vozila:</td>
            <td className="column8 displayTextFlex verticalAlign" style={{borderBottom: '1px solid black'}}></td>
            <td className="column9 displayTextFlex verticalAlign" colSpan="3">Ispravnosti prikolice:</td>
            <td className="column12 displayTextFlex verticalAlign"  style={{borderBottom: '1px solid black'}}></td>
          </tr>
          
          {/* Preuzimanje prikolice */}
          <tr>
            <td className="column0 bold verticalAlign" colSpan="5"  style={{ borderLeft: '2px solid black', borderRight: '2px solid black'}}>
              Preuzimanje prikolice (frigo ili cerada obavezno popuniti polja)
            </td>
            <td className="column5"></td>
            <td className="column6"></td>
            <td className="column7"></td>
            <td className="column8"></td>
            <td className="column9"></td>
            <td className="column10"></td>
            <td className="column11"></td>
            <td className="column12"></td>
            <td className="column13"></td>
          </tr>
          
          <tr>
            <td className="column0 empty-cell" style={{ borderLeft: '2px solid black'}}></td>
            <td className="column1 empty-cell"></td>
            <td className="column2 empty-cell"></td>
            <td className="column3 empty-cell"></td>
            <td className="column4 empty-cell" style={{borderRight: '2px solid black'}}></td>
            <td className="column5"></td>
            <td className="column6" colSpan="3" rowSpan="2">
              Potvrdjujem da sam primio vozilo bez vidljivih nedostataka
            </td>
            <td className="column9"></td>
            <td className="column10"></td>
            <td className="column11"></td>
            <td className="column12"></td>
            <td className="column13"></td>
          </tr>
          
          {/* Razduženje prikolice */}
          <tr>
            <td className="column0 bold verticalAlign" colSpan="5" style={{ borderLeft: '2px solid black', borderRight: '2px solid black',borderBottom: '2px solid black'}}>
              Razduženje prikolice (frigo ili cerada obavezno popuniti polja)
            </td>
            <td className="column5"></td>
            <td className="column9"></td>
            <td className="column10"></td>
            <td className="column11"></td>
            <td className="column12"></td>
            <td className="column13"></td>
          </tr>
          
          {/* M.P potpis */}
          <tr>
            <td className="column0 empty-cell" style={{borderLeft: '2px solid black',borderBottom: '2px solid black'}}></td>
             <td className="column1 empty-cell" style={{borderBottom: '2px solid black'}}></td>
            <td className="column2 empty-cell" style={{borderBottom: '2px solid black'}}></td>
            <td className="column3 empty-cell" style={{borderBottom: '2px solid black'}}></td>
            <td className="column4 empty-cell"style={{borderRight: '2px solid black',borderBottom: '2px solid black'}}></td>
            <td className="column5" style={{borderBottom: 'none'}}></td>
            <td className="column6 empty-cell"></td>
            <td className="column7 empty-cell"></td>
            <td className="column8 empty-cell"></td>
            <td className="column9"></td>
            <td className="column10"></td>
            <td className="column11"></td>
            <td className="column12 text-right">M.P</td>
            <td className="column13"></td>
          </tr>
          
          {/* Prazan red */}
          <tr>
            <td className="borderLeftAndRightNone column0 empty-cell" colSpan="2" style={{borderTop: 'none', borderBottom: 'none'}}></td>
            <td className="borderLeftAndRightNone column2" style={{borderTop: 'none', borderBottom: 'none'}}></td>
            <td className="borderLeftAndRightNone column3" style={{borderTop: 'none', borderBottom: 'none'}}></td>
            <td className="borderLeftAndRightNone column4" style={{borderTop: 'none', borderBottom: 'none'}}></td>
            <td className="borderLeftAndRightNone column5" style={{borderTop: 'none', borderBottom: 'none'}}></td>
            <td className="column6"></td>
            <td className="column7"></td>
            <td className="column8"></td>
            <td className="column9"></td>
            <td className="column10"></td>
            <td className="column11"></td>
            <td className="column12"></td>
            <td className="column13"></td>
          </tr>
          
          {/* Kreirao nalog */}
          <tr>
            <td className="column0 bold displayTextFlex verticalAlign" colSpan="2" style={{border: 'none'}}>Kreirao nalog:</td>
            <td className="column2 displayTextFlex verticalAlign" colSpan="3" style={{borderTop: 'none',borderLeft: 'none',borderRight: 'none', borderBottom: '1px solid black'}}>{kreiraoNalog}</td>
            <td className="column5" style={{border: 'none'}}></td>
            <td className="column6 empty-cell" colSpan="2"></td>
            <td className="column8"></td>
            <td className="column9"></td>
            <td className="column10"></td>
            <td className="column11"></td>
            <td className="column12"></td>
            <td className="column13"></td>
          </tr>
          
          {/* Prazan red */}
          <tr>
            <td className="column0 empty-cell" colSpan="2" style={{border: 'none'}}></td>
            <td className="column2" style={{border: 'none'}}></td>
            <td className="column3" style={{border: 'none'}}></td>
            <td className="column4" style={{border: 'none'}}></td>
            <td className="column5" style={{border: 'none'}}></td>
            <td className="column6 empty-cell" colSpan="2" style={{borderBottom: '1px solid black'}}></td>
            <td className="column8" style={{borderBottom: '1px solid black'}}></td>
            <td className="column9"></td>
            <td className="column10 empty-cell" style={{borderBottom: '1px solid black'}}></td>
            <td className="column11 empty-cell" style={{borderBottom: '1px solid black'}}></td>
            <td className="column12 empty-cell" style={{borderBottom: '1px solid black'}}></td>
            <td className="column13" style={{borderBottom: '1px solid black'}}></td>
          </tr>
          
          {/* Zaprimio nalog i potpisi */}
          <tr>
            <td className="column0 bold displayTextFlex verticalAlign" colSpan="2" style={{border: 'none'}}>Zaprimio nalog od vozača:</td>
            <td className="column2 displayTextFlex verticalAlign" colSpan="3" style={{borderTop: 'none',borderLeft: 'none',borderRight: 'none', borderBottom: '1px solid black'}}></td>
            <td className="column5" style={{border: 'none'}}></td>
            <td className="column6 displayTextFlex verticalAlign" colSpan="3">popis vozača</td>
            <td className="column7"></td>
            <td className="column8 displayTextFlex verticalAlign" colSpan="4">potpis lica ovlašćenog za izdavanje putnog naloga</td>
          </tr>
        </tbody>
      </table>
  
    </div>
    </>
  );
};

export default PutniNalogZaStampu;